<div *ngIf="hasError" class="mt-1 text-red-500 text-[10px] font-medium">
  {{ errorMessage }}
</div>
